<template>
    <div>
        <v-select ref="select" label="name"
                  :filterable="false"
                  :options="options"
                  @search="onSearch"
                  v-model="selected"
                  @input="inputChanged"
                  :disabled="disabled"
                  v-bind:name="'search_' + _uid">
            <template slot="no-options">
                <span class="text-danger">
                    {{ emptyMessage }}
                </span>
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center"
                     @click="onSelected($event, { id: option.id, text: option.text, textEn: option.textEn})">
                    {{ isEnVersion ? option.textEn : option.text }}
                </div>
            </template>
            <template slot="selected-option" scope="option">
                <div class="selected d-center"
                     @click="onSelected($event, { id: option.id, text: option.text, textEn: option.textEn})">
                    {{ isEnVersion ? option.textEn : option.text }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import _ from 'lodash';
    import http from '../../services/http.service';
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {
            'v-select': vSelect
        },
        props: {
            value: [Number, String],
            type: String,
            disabled: {
                type: Boolean,
                default: false
            },
            loadByParentSort: {
                type: Boolean,
                default: false
            },
            parentSort: {
                type: Number,
                default: 0
            },
            searchMinLength: {
                type: Number,
                default: 3
            }
        },
        data: function () {
            return {
                options: [],
                selected: { id: this.value },
                searchStr: ''
            }
        },
        methods: {
            onSearch(search, loading) {
                this.searchStr = search;
                if (search.length < this.searchMinLength) {
                    return
                }

                if (loading) {
                    loading(true);
                }
                this.search(loading, search, this);
            },
            search: _.debounce((loading, search, vm) => {
                let url = '';
                if (vm.loadByParentSort) {
                    url = `/api/search/bySort?sort=${vm.parentSort}&searchString=${encodeURIComponent(search)}&selected=${vm.value}`;
                } else {
                    url = `/api/search/byType?type=${vm.type}&searchString=${encodeURIComponent(search)}&selected=${vm.value}`;
                }

                http.get(url).then(result => {
                    vm.options = result.data;
                    if (loading) {
                        loading(false);
                    }
                });
            }, 350),
            onSelected(event, selectedOption) {
                this.selected = selectedOption;
                this.$emit('input', this.selected.id, this.selected);
            },
            inputChanged(event) {
                if (this.selected) {
                    this.$emit('input', this.selected.id, this.selected);
                } else {
                    this.$emit('input', null);
                }
            },
            loadInitialVal: function (caller) {
                if (!this.value) {
                    return;
                }

                const url = `/api/search/${this.value}`;
                http.get(url).then(result => {
                    if (result.data) {
                        this.selected = result.data;
                    }
                });
            }
        },
        computed: {
            emptyMessage: function () {
                return (this.searchStr && this.searchStr.length >= this.searchMinLength) ? this.$t('searchDropdown.noResults') : this.$t('searchDropdown.minSearchChars', { searchMinLength: this.searchMinLength });
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            }
        },
        mounted: function () {
            if (this.value) {
                this.loadInitialVal();
            }

            if (this.searchMinLength <= 0) {
                this.onSearch('');
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    // console.log(newVal);
                    this.loadInitialVal();
                }
            }
        }
    }
</script>

<style scoped>
</style>
